/**
 * @license
 * Copyright 厦门乾元盛世科技有限公司 All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file.
 */


// matchMedia polyfill for
// https://github.com/WickyNilliams/enquire.js/issues/82
if (typeof window !== 'undefined') {
    const /** @type {?} */ matchMediaPolyfill = function matchMediaPolyfill(mediaQuery: string): MediaQueryList {
        return {
            media: mediaQuery,
            matches: false,
/**
 * @return {?}
 */
addListener() {
            },
/**
 * @return {?}
 */
removeListener() {
            },
        };
    };
    window.matchMedia = window.matchMedia || matchMediaPolyfill;
}


const /** @type {?} */ dimensionMap = {
    xs: '480px',
    sm: '768px',
    md: '992px',
    lg: '1200px',
    xl: '1600px',
};

import { Component, Input, Output, EventEmitter, ElementRef, Renderer } from '@angular/core';
import { OnInit, OnDestroy, HostBinding, ViewEncapsulation, Optional, Host } from '@angular/core';
import classNames from 'classnames';
import { Layout } from './layout';

export type TriggerType = 'clickTrigger' | 'responsive';
/**
 * Sider
 */
export class Sider implements OnInit, OnDestroy {
/**
 * 样式前缀
 */
prefixCls = 'ant-layout-sider';

     collapsible = false;

     collapsed = false;

     reverseArrow = false;

     width = 200;

     collapsedWidth = 64;

     breakpoint: 'xs' | 'sm' | 'md' | 'lg' | 'xl';

     trigger: any;
/**
 * 用户CSS样式
 */
class: string;
/**
 * collapse事件
 */
collapse = new EventEmitter<{ collapsed: boolean, type: TriggerType }>();
public below: false;
private mql: any;
private _responsiveHandler: any;
/**
 * @param {?} renderer
 * @param {?} elementRef
 * @param {?} layout
 */
constructor(
private renderer: Renderer,
private elementRef: ElementRef,
private layout: Layout) {
        if (layout) {
            layout.hasSilder = true;
        }
    }
/**
 * @return {?}
 */
ngOnInit(): void {
        let /** @type {?} */ matchMedia;
        if (typeof window !== 'undefined') {
            matchMedia = window.matchMedia;
        }
        if (matchMedia && this.breakpoint && (this.breakpoint in dimensionMap)) {
            this.mql = matchMedia(`(max-width: ${dimensionMap[this.breakpoint]})`);
        }
        if (this.mql) {
            this._responsiveHandler = this.responsiveHandler.bind(this);
            this.mql.addListener(this._responsiveHandler);
            this.responsiveHandler(this.mql);
        }
    }
/**
 * @return {?}
 */
ngOnDestroy(): void {
        if (this.mql) {
            this.mql.removeListener(this._responsiveHandler);
            this.mql = null;
        }
        this._responsiveHandler = null;
    }
/**
 * @return {?}
 */
get classes(): string {
        const /** @type {?} */ siderWidth = this.collapsed ? this.collapsedWidth : this.width;
        const /** @type {?} */ siderCls = classNames(this.class, this.prefixCls, {
            [`${this.prefixCls}-collapsed`]: this.collapsed,
            [`${this.prefixCls}-has-trigger`]: !!this.trigger,
            [`${this.prefixCls}-below`]: this.below,
            [`${this.prefixCls}-zero-width`]: siderWidth === 0
        });
        return siderCls;
    }
/**
 * @return {?}
 */
get siderFlex(): string {
        const /** @type {?} */ siderWidth = this.collapsed ? this.collapsedWidth : this.width;
        return `0 0 ${siderWidth}px`;
    }
/**
 * @return {?}
 */
get siderWidth(): string {
        const /** @type {?} */ siderWidth = this.collapsed ? this.collapsedWidth : this.width;
        return `${siderWidth}px`;
    }
/**
 * @param {?} mql
 * @return {?}
 */
responsiveHandler(mql: any): void {
        this.below = mql.matches;
        if (this.collapsed !== mql.matches) {
            this.setCollapsed(mql.matches, 'responsive');
        }
    }
/**
 * @param {?} collapsed
 * @param {?} type
 * @return {?}
 */
setCollapsed(collapsed: boolean, type: TriggerType): void {
        this.collapsed = collapsed;
        this.collapse.emit({ collapsed, type });
    }
/**
 * @return {?}
 */
toggle(): void {
        const /** @type {?} */ collapsed = !this.collapsed;
        this.setCollapsed(collapsed, 'clickTrigger');
    }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'ant-layout-sider',
    template: `
        <ng-content></ng-content>
        <div *ngIf="collapsible || (below && collapsedWidth == 0)">
            <div (click)="toggle()" [class]="prefixCls + '-zero-width-trigger'" *ngIf="!collapsedWidth">
                <ant-icon type="bars"></ant-icon>
            </div>
            <div (click)="toggle()" [class]="prefixCls + '-trigger'" *ngIf="collapsedWidth">
                <ant-icon [type]="reverseArrow ? 'left' : 'right' " *ngIf="collapsed"></ant-icon>
                <ant-icon [type]="reverseArrow ? 'right' : 'left' " *ngIf="!collapsed"></ant-icon>
            </div>
        </div>
    `,
    encapsulation: ViewEncapsulation.None
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Renderer, },
{type: ElementRef, },
{type: Layout, decorators: [{ type: Optional }, { type: Host }, ]},
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'prefixCls': [{ type: Input },],
'collapsible': [{ type: Input },],
'collapsed': [{ type: Input },],
'reverseArrow': [{ type: Input },],
'width': [{ type: Input },],
'collapsedWidth': [{ type: Input },],
'breakpoint': [{ type: Input },],
'trigger': [{ type: Input },],
'class': [{ type: Input },],
'collapse': [{ type: Output },],
'classes': [{ type: HostBinding, args: ['class', ] },],
'siderFlex': [{ type: HostBinding, args: ['style.flex', ] },],
'siderWidth': [{ type: HostBinding, args: ['style.width', ] },],
};
}

function Sider_tsickle_Closure_declarations() {
/** @type {?} */
Sider.decorators;
/**
 * @nocollapse
 * @type {?}
 */
Sider.ctorParameters;
/** @type {?} */
Sider.propDecorators;
/**
 * 样式前缀
 * @type {?}
 */
Sider.prototype.prefixCls;
/** @type {?} */
Sider.prototype.collapsible;
/** @type {?} */
Sider.prototype.collapsed;
/** @type {?} */
Sider.prototype.reverseArrow;
/** @type {?} */
Sider.prototype.width;
/** @type {?} */
Sider.prototype.collapsedWidth;
/** @type {?} */
Sider.prototype.breakpoint;
/** @type {?} */
Sider.prototype.trigger;
/**
 * 用户CSS样式
 * @type {?}
 */
Sider.prototype.class;
/**
 * collapse事件
 * @type {?}
 */
Sider.prototype.collapse;
/** @type {?} */
Sider.prototype.below;
/** @type {?} */
Sider.prototype.mql;
/** @type {?} */
Sider.prototype._responsiveHandler;
/** @type {?} */
Sider.prototype.renderer;
/** @type {?} */
Sider.prototype.elementRef;
/** @type {?} */
Sider.prototype.layout;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
